<template>
  <div class="doses-list">
    <h4>{{ title }}:</h4>

    <div v-for="(dose, index) in dosesSafe" :key="index">
      <div class="doses-list-item" :class="dose.cor" @click="onClickDose(dose)">
        <strong>{{ dose.dose }}</strong>

        <div v-if="tag === 'covid19'">
          <div v-for="(ap, i) in dose.aplicadas || []" :key="i">
            {{ ap.dt_plc_br }}
          </div>
        </div>

        <div v-else>{{ dose.dt_plc_br }}</div>
      </div>
    </div>

    <SalvarVacinaModal
      v-model="modalShow"
      :title="title"
      :item="item"
      :dose="selectedDose"
      :mode="mode"
      @saved="$emit('saved', $event)"
      @updated="$emit('updated', $event)"
    />
  </div>
</template>

<script>
import SalvarVacinaModal from '@/pages/Imunizacao/components/SalvarVacinaModal.vue'

export default {
  name: 'ItemDoses',
  components: { SalvarVacinaModal },

  props: {
    title: { type: String, default: '' },
    doses: { type: [Array, Boolean], default: false },
    tag: { type: String, default: '' },
    item: { type: Object, required: true },
  },

  data() {
    return {
      modalShow: false,
      selectedDose: null,
      mode: 'create', // create | edit
    }
  },

  computed: {
    dosesSafe() {
      return Array.isArray(this.doses) ? this.doses : []
    },
  },

  methods: {
    /**
     * Manipula o clique em uma dose de vacina.
     * Define o cidadão selecionado e abre o modal para criação ou edição da dose.
     * @param {Object} dose Dados da dose selecionada
     */
    onClickDose(dose) {
      if (!dose) return

      // só insere se for white ou red
      if (dose.cor === 'white' || dose.cor === 'red') {
        this.mode = 'create'
        this.selectedDose = dose
        this.modalShow = true
        return
      }

      // edição depende de orig==3
      this.mode = 'edit'
      this.selectedDose = dose
      this.modalShow = true
    },
  },
}
</script>

<style scoped lang="scss">
.doses-list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  gap: 20px;
  margin: 20px 0;
  background-color: #f1f0f5;
  padding: 15px;

  h4 {
    font-size: 16px;
    margin-bottom: 0;
    width: 15%;
  }

  .doses-list-item {
    cursor: pointer;
    background-color: #fff;
    min-width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    border: 1px solid #ccc;
    color: #000;
    border-radius: 6px;

    &.red {
      background: #ffb3b3 !important;
    }
    &.green {
      background: #b3ffb3;
    }
    &.white {
      background: #fff;
    }
  }
}
</style>
